import { motion } from "framer-motion";

const FEATURES = [
  {
    name: "Psychology Today",
    href: "https://www.psychologytoday.com/",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_fresh-start-journey/artifacts/riw42vo0_image%20%282%29.png",
  },
  {
    name: "The Best Toronto",
    href: "https://thebesttoronto.com/best-drug-rehab-centres-toronto/",
    img: "https://icon.horse/icon/thebesttoronto.com",
    text: "The Best Toronto",
  },
  {
    name: "Toronto Travel Guide",
    href: "https://toronto-travel-guide.com/best-drug-rehab-centres-toronto",
    img: "https://icon.horse/icon/toronto-travel-guide.com",
    text: "Toronto Travel Guide",
  },
];

const FeaturedOn = () => (
  <section
    data-testid="featured-on"
    className="bg-sand2 py-12 md:py-16 border-y border-line"
  >
    <div className="mx-auto max-w-[1300px] px-5 md:px-10">
      <p className="text-center text-[11px] uppercase tracking-[0.32em] text-ink2 font-semibold mb-8">
        Featured on
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-8">
        {FEATURES.map((f, i) => (
          <motion.a
            key={f.name}
            href={f.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Featured on ${f.name}`}
            data-testid={`featured-${f.name.toLowerCase().replace(/\s+/g, '-')}`}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            whileHover={{ y: -2 }}
            className="group inline-flex items-center gap-3 grayscale hover:grayscale-0 transition-all"
          >
            <img
              src={f.img}
              alt={f.name}
              className="h-10 md:h-12 w-auto object-contain opacity-75 group-hover:opacity-100 transition-opacity"
              loading="lazy"
              draggable={false}
            />
            {f.text && (
              <span className="font-serif text-forest text-lg md:text-xl font-semibold hidden sm:block">
                {f.text}
              </span>
            )}
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturedOn;
